import { render, staticRenderFns } from "./RiskScale.vue?vue&type=template&id=d986ed62&scoped=true&"
import script from "./RiskScale.vue?vue&type=script&lang=js&"
export * from "./RiskScale.vue?vue&type=script&lang=js&"
import style0 from "./RiskScale.vue?vue&type=style&index=0&id=d986ed62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d986ed62",
  null
  
)

component.options.__file = "packages/cb-components-portfolio/src/components/main/RiskScale.vue"
export default component.exports